import {Pressable, Text, StyleSheet} from "react-native";
import React from "react";
import {useTheme} from "@react-navigation/native";

export default function MainButton(props) {
    const { onPress, title = 'Save' } = props;

    const theme = useTheme();
    const styles = StyleSheet.create({
        button: {
            display: 'flex',
            width: 48,
            height:48,
            backgroundColor: theme.colors.scheme[3],
            fontFamily: 'Roboto-Regular',
            marginHorizontal:4,
            borderWidth: 0,
            borderRadius:100,
            alignItems:'center',
            justifyContent:'center'
        },
        text: {
            color: theme.colors.scheme[4],
        }
    });
    return (
        <Pressable style={styles.button} onPress={onPress}>
            <Text style={styles.text}>{title}</Text>
        </Pressable>
    );
}